import { StyleSheet, Text, View } from 'react-native'
import React from 'react'
import { NativeStackScreenProps } from '@react-navigation/native-stack'
import { PrivateStackParamList } from '../../navigationApp/types'
import { ThemedPressable, ThemedView } from '../../theme'
import BackButton from '../../sharedComponents/BackButton/BackButton'
import Typography from '../../sharedComponents/typography/Typography'
import { ColorTokens, TypographyTypeDLS } from '@voltmoney/schema'
import InfoIcon from '../../../assets/Icons/InfoIcon'
import { CaretRight, X } from '../../sharedComponents/Icons/index';
import FileIcon from '../../../assets/Icons/FileIcon'
import LockedIcon from '../../../assets/Icons/LockedIcon'
import PartnersIcon from '../../../assets/Icons/PartnersIcon'
import ScreenWrapper from '@app/hoc/ScreenWrapper'
import PageHeaders from '@app/sharedComponents/CommonHeader/CommonHeader'
import { ThemedText } from '@app/theme/Components'
import { useDarkMode } from '@app/utils'


type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'ABOUT_US'>
const isDarkMode = useDarkMode()
type LIST_ITEM_TYPE = {
    id: number,
    label: string
    icon: React.ReactNode,
    link: keyof PrivateStackParamList,
    uri?: string
}[]


const LIST_ITEM: LIST_ITEM_TYPE = [{
    id: 1,
    label: 'Terms of Service',
    icon: <FileIcon size={18} color={isDarkMode ? '#ffffff' : "#000000"} />,
    link: 'WEBVIEW_SCREEN',
    uri: 'https://www.voltmoney.in/terms?showHeader=false',
},
{
    id: 2,
    label: 'Privacy policy',
    icon: <LockedIcon size={18} color={isDarkMode ? '#ffffff' : "#000000"}  />,
    link: 'WEBVIEW_SCREEN',
    uri: 'https://voltmoney.in/privacy?showHeader=false',
}, {
    id: 3,
    label: 'Lending partners',
    icon: <PartnersIcon size={18} color={isDarkMode ? '#ffffff' : "#000000"}  />,
    link: 'LENDING_PARTNERS',
}, {
    id: 4,
    label: 'Product details',
    icon: <InfoIcon  size={18} color={isDarkMode ? '#ffffff' : "#000000"}  />,
    link: 'PRODUCT_DETAILS',
}]

const AboutUs = ({ navigation  ,route }: ScreenProps) => {
    return (
    <>
        <PageHeaders label="About us" pageName={route?.name} navigation={navigation} showNeedHelp={false}/>
        <ThemedView bg='bg-surface-primary' flex={1}>
            <ThemedView paddingHorizontal='lg' mt='sm'>
                {LIST_ITEM.map((item) => {
                    return (
                        <ThemedPressable key={item?.id} onPress={() => navigation.navigate(item.link, { url: item?.uri, label: item?.label })} borderBottomColor='border-primary' borderBottomWidth={1} justifyContent='space-between' paddingVertical='xl' flexDirection='row' alignItems='center'>
                            <ThemedView flexDirection='row'>
                                <ThemedView mr='md'>
                                    {item?.icon}
                                </ThemedView>
                                <ThemedText color='text-primary' variant='b3m' style={{ maxWidth: 200 }} numberOfLines={1} ellipsizeMode='tail'>
                                        {item?.label}
                                </ThemedText>
                            </ThemedView>
                            <CaretRight size={14} style={{ color: isDarkMode ? '#ffffff' : "#000000" }} />
                        </ThemedPressable>
                    )
                })}
            </ThemedView>
        </ThemedView>
    </>
    )
}

export default AboutUs

const styles = StyleSheet.create({})